<template>
  <div>
    <div
      v-for="(partyInfo, index) of reversedRelatedPartiesInfo"
      :key="index"
    >
      <template v-if="lastIndexFilteredRelatedPartiesInfo === -1 || lastIndexFilteredRelatedPartiesInfo === index">
        <representative-form
          :form-model="formModel"
          :party-info="partyInfo"
          :view-mode="viewMode"
        >
        </representative-form>
      </template>
    </div>
  </div>
</template>

<script>
import RepresentativeForm from './representative-form.vue';
import { casePartyRoleEnum } from '@/helpers/enum';

export default {
  inject: ['$validator'],
  components: { RepresentativeForm },
  props: ['formModel', 'required', 'viewMode'],
  data() {
    return { casePartyRoleEnum };
  },
  computed: {
    reversedRelatedPartiesInfo() {
      return [...(this.formModel.relatedPartiesInfo || [])].reverse();
    },
    lastIndexFilteredRelatedPartiesInfo() {
      return this.reversedRelatedPartiesInfo
        .findIndex(partyInfo => this.isInRepresentativeRoles(partyInfo.casePartyRole)
          && this.formModel.casePartyObjectKey === partyInfo.casePartyObjectKey);
    },
  },
  methods: {
    isInRepresentativeRoles(casePartyRole) {
      const representativeRoles = {
        [this.casePartyRoleEnum.agent]: true,
        [this.casePartyRoleEnum.lawyer]: true,
        [this.casePartyRoleEnum.representative]: true,
        [this.casePartyRoleEnum.regent]: true,
        [this.casePartyRoleEnum.guardian]: true,
        [this.casePartyRoleEnum.liquidator]: true,
        [this.casePartyRoleEnum.judicialGuard]: true,
        [this.casePartyRoleEnum.cessationObserver]: true,
      };
      return !!representativeRoles[casePartyRole];
    },
  },
};
</script>
